import styled, { css } from 'styled-components';

export const Pager = styled.div(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: ${theme.sz.s1};
    padding: ${theme.sz.s05};
    border-radius: ${theme.bo.round};
    background-color: hsla(0, 0%, 0%, 0.45);
    backdrop-filter: blur(6px);
    color: ${theme.co.neutral99};
  `,
);

export const PagerButton = styled.button(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${theme.sz.s8};
    height: ${theme.sz.s8};
    padding: 0;
    border: 0;
    border-radius: ${theme.bo.round};
    background: none;
    color: inherit;
    font-size: ${theme.sz.s5};
    cursor: pointer;

    &:hover {
      background-color: hsla(0, 0%, 100%, 0.2);
    }

    ${theme.focusVisible};

    [dir='rtl'] & {
      transform: scaleX(-1);
    }
  `,
);

export const Position = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
    min-width: ${theme.sz.s12};
    font-size: ${theme.sz.s3};
    text-align: center;
  `,
);
